<div id="app-error">
  <iframe src="/assets/errors/500.html"></iframe>
</div>
